/**
 * @file  FAQ
 * @author yuanyaojia@baijia.com
 * @date 2021-04-21
 */


import React, {useEffect, useState, useContext} from 'react';
import {message, Divider} from 'antd';
import {getByChannelCode} from '~/service/cms';
import {BasicLayoutContext} from '~/layout/BasicLayout';

import './index.less';

const codeList = ['channel_ir_qa'];

function FAQ() {
    const [channelIrQaList, setChannelIrQaList] = useState([]);
    const layoutContext = useContext(BasicLayoutContext);
    const {isMobile} = layoutContext ?? {};

    useEffect(() => {
        getByChannelCode({codeList})
            .then(({data}) => {
                const {channel_ir_qa: {contentResponseList}} = data;
                setChannelIrQaList(contentResponseList);
            })
            .catch(() => {
                message.error('获取首页信息失败');
            });
    }, []);

    return (
        <div className="faq-content">
            {
                isMobile && (
                    <>
                        <div className="faq-content-title">
                            Investor FAQ
                        </div>
                        <Divider />
                    </>
                )
            }
            {
                channelIrQaList.map(item => (
                    <div key={item.id} className="aq-question-anwser">
                        <div className="faq-question">
                            {item.content.question}
                        </div>
                        <div className="faq-answer">
                            {item.content.answer}
                        </div>
                    </div>
                ))
            }
        </div>
    );
}

export default FAQ;
